export default __webpack_public_path__ + "static/media/Tammy_900.c70ef9dc.webp";